import SOC2 from "../../../../contents/handbook/company/_snippets/soc2.mdx";
import * as React from 'react';
export default {
  SOC2,
  React
};